// Importing language modules for different sections and combining them into a single language module
import { appLanguage as common } from "./Common/index.i18n";
import { appLanguage as adminAuth } from "./Admin/Auth/index.i18n";
import { adminCms, adminUserManagement, adminUpdateProfile, bookRequest } from "./Admin";

/**
 * Language resource for the entire application.
 * @typedef {Object} LanguageResource
 * @property {Object} text - Text content for different sections of the application.
 * @property {Object} validation - Validation messages for different sections of the application.
 */

/**
 * Function to provide a unified language object for the entire application.
 * @returns {LanguageResource} Language resource for the entire application.
 */
export default function lang() {
  return {
    text: {
      common: common.text,
      adminAuth: adminAuth.text,
      adminUserManagement: adminUserManagement.text,
      adminUpdateProfile: adminUpdateProfile.text,
      adminCms: adminCms.text,
      bookRequest: bookRequest.text,
    },
    validation: {
      common: common.validation,
      adminAuth: adminAuth.validation,
      adminUserManagement: adminUserManagement.validation,
      adminUpdateProfile: adminUpdateProfile.validation,
      adminCms: adminCms.validation,
      bookRequest: bookRequest.validation,
    },
  };
}
